import request from '@/utils/request'
//get
export function getAuthByProduct(){
  return request({
    url: `/auth/`,
    method:'GET'
  })
}
export function getAuthBySearch(params){
  return request({
    url: `/auth/${params}`,
    method:'GET'
  })
}

export function verifyCode(data){
  return request({
    url: '/auth/verify_code/',
    method:'POST',
    data
  })
}
export function getCertificateById(id){
  return request({
    url: `/auth/${id}/certificate/`,
    method:'GET',
  })
}
export function getProductEditions(){
  return request({
    url: `/auth/fbi_editions/`,
    method:'GET'
  })
}
export function getXZEditions(){
  return request({
    url: `/auth/xz_editions/`,
    method:'GET'
  })
}
export function getProductModules(){
  return request({
    url: `/auth/fbi_modules/`,
    method:'GET'
  })
}
export function addTrail(data){
  return request({
    url: '/auth/trail/',
    method:'POST',
    data
  })
}

export function addUserPrice(id, data){
  return request({
    url: `/auth/${id}/add_user_price/`,
    method:'POST',
    data
  })
}

export function addUser(id, data){
  return request({
    url: `/auth/${id}/add_user/`,
    method:'POST',
    data
  })
}

export function addMonthPrice(id, data){
  return request({
    url: `/auth/${id}/add_days_price/`,
    method:'POST',
    data
  })
}

export function addMonth(id, data){
  return request({
    url: `/auth/${id}/add_days/`,
    method:'POST',
    data
  })
}

export function buyPrice(data){
  return request({
    url: `/auth/buy_price/`,
    method:'POST',
    data
  })
}

export function buy(data){
  return request({
    url: `/auth/buy/`,
    method:'POST',
    data
  })
}
export function modify_price(id, data){
  return request({
    url: `/auth/${id}/modify_price/`,
    method:'POST',
    data
  })
}

export function modify(id, data){
  return request({
    url: `/auth/${id}/modify/`,
    method:'POST',
    data
  })
}

//update
export function updateAuth(id, data){
  return request({
    url: `/auth/${id}/`,
    method:'PATCH',
    data
  })
}

//试用延期
export function trialDelay(id){
  return request({
    url: `/auth/${id}/delay`,
    method:'GET',
  })
}

export function setOffline(data){
  return request({
    url: `/offline_auth/set_code/`,
    method:'POST',
    data
  })
}


export function add_module(id, data){
  return request({
    url: `/auth/${id}/add_module/`,
    method:'POST',
    data
  })
}

export function add_module_price(id, data){
  return request({
    url: `/auth/${id}/add_module_price/`,
    method:'POST',
    data
  })
}

export function trail_module(id, data){
  return request({
    url: `/auth/${id}/trail_module/`,
    method:'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/auth.js